
import img1 from './assets/HomePagePics/Palomino Home Page.webp'
import img2 from './assets/HomePagePics/mMqDXo4VQIeRfrObnzu57w_thumb_3680.jpg'
import img3 from './assets/HomePagePics/mNMU2Ah0RQCG9WxK+l4DfQ_thumb_367e.jpg'
import img4 from './assets/HomePagePics/u4nmejO7SfG615RK4a2MPw_thumb_367d.jpg'
import img5 from './assets/HomePagePics/22-web-or-mls-DSC04703_final.jpg'
import img6 from './assets/HomePagePics/11-web-or-mls-DSC04648.jpg'
import img7 from './assets/HomePagePics/25-web-or-mls-DSC04713.jpg'
import img8 from './assets/HomePagePics/xH9+ZCXlQZKGQsR96AC0FA_thumb_3647.jpg'
import img9 from './assets/HomePagePics/bcdIvlx2Q96qh7bL02FqnA_thumb_364d.jpg'
import img12 from './assets/HomePagePics/41+5rAJwR8GrQ+p82L5Zqg_thumb_3646.jpg'
import img13 from './assets/HomePagePics/4-web-or-mls-DJI_0464.jpg'
import img14 from './assets/HomePagePics/1-web-or-mls-DJI_0449.jpg'
import buyerIncentive from './assets/HomePagePics/Prices.jpg'
import newImg1 from './assets/HomePagePics/newPics/4-print-13.jpg'
import newImg2 from './assets/HomePagePics/newPics/5-print-DJI_0475.jpg'
import newImg3 from './assets/HomePagePics/newPics/6-print-15.jpg'
import newImg4 from './assets/HomePagePics/newPics/10-print-VIBE8840.jpg'
import newImg5 from './assets/HomePagePics/newPics/12-print-21.jpg'
import newImg6 from './assets/HomePagePics/newPics/13-print-VIBE8855.jpg'
import newImg7 from './assets/HomePagePics/newPics/14-print-VIBE8860.jpg'
import newImg8 from './assets/HomePagePics/newPics/18-print-01.jpg'
import newImg9 from './assets/HomePagePics/newPics/19-print-02.jpg'
import newImg10 from './assets/HomePagePics/newPics/19-print-VIBE8885.jpg'
import newImg11 from './assets/HomePagePics/newPics/20-print-VIBE8890.jpg'
import newImg12 from './assets/HomePagePics/newPics/21-print-VIBE8895.jpg'
import newImg13 from './assets/HomePagePics/newPics/23-print-06.jpg'
import newImg14 from './assets/HomePagePics/newPics/25-print-08.jpg'
import newImg15 from './assets/HomePagePics/newPics/25-print-VIBE8920.jpg'
import newImg16 from './assets/HomePagePics/newPics/26-print-09.jpg'

import card1img1 from './assets/FloorPlans/card1/Model 1551L-Main-8.8.23.jpg'
import card1img2 from './assets/FloorPlans/card1/Model 1551L- Upper.jpg'
import card1img3 from './assets/FloorPlans/card1/Model 1551L- Basement.jpg'

import card2img1 from './assets/FloorPlans/card2/Model 1551R-Main.webp'
import card2img2 from './assets/FloorPlans/card2/Model 1551R- Upper.webp'
import card2img3 from './assets/FloorPlans/card2/Model 1551R- Basement.webp'

import card3img1 from './assets/FloorPlans/card3/Model 1558-main.webp'
import card3img2 from './assets/FloorPlans/card3/Model 1558-Upper.jpg'
import card3img3 from './assets/FloorPlans/card3/Model 1558-Basement.jpg'


const homeImages = [
    {
        'id': 1,
        'original': img1,
        "thumbnail": img1,
        'originalClass': 'homeImgs',
        "ctaLink": '#/floor-plans',
        "ctaLabel": "Explore Floorplans",
    },
    {
        'id': 4,
        'original': buyerIncentive,
        "thumbnail": buyerIncentive,
        'originalClass': 'homeImgs'
    },
    {
        'id': 14,
        'original': newImg1,
        "thumbnail": newImg1,
        'originalClass': 'homeImgs'
    },
    {
        'id': 15,
        'original': newImg2,
        "thumbnail": newImg2,
        'originalClass': 'homeImgs'
    },
    {
        'id': 16,
        'original': newImg3,
        "thumbnail": newImg3,
        'originalClass': 'homeImgs'
    },
    {
        'id': 17,
        'original': newImg4,
        "thumbnail": newImg4,
        'originalClass': 'homeImgs'
    },
    {
        'id': 18,
        'original': newImg5,
        "thumbnail": newImg5,
        'originalClass': 'homeImgs'
    },
    {
        'id': 19,
        'original': newImg6,
        "thumbnail": newImg6,
        'originalClass': 'homeImgs'
    },
    {
        'id': 20,
        'original': newImg7,
        "thumbnail": newImg7,
        'originalClass': 'homeImgs'
    },
    {
        'id': 21,
        'original': newImg8,
        "thumbnail": newImg8,
        'originalClass': 'homeImgs'
    },
    {
        'id': 22,
        'original': newImg9,
        "thumbnail": newImg9,
        'originalClass': 'homeImgs'
    },
    {
        'id': 23,
        'original': newImg10,
        "thumbnail": newImg10,
        'originalClass': 'homeImgs'
    },
    {
        'id': 24,
        'original': newImg11,
        "thumbnail": newImg11,
        'originalClass': 'homeImgs'
    },
    {
        'id': 25,
        'original': newImg12,
        "thumbnail": newImg12,
        'originalClass': 'homeImgs'
    },
    {
        'id': 26,
        'original': newImg13,
        "thumbnail": newImg13,
        'originalClass': 'homeImgs'
    },
    {
        'id': 27,
        'original': newImg14,
        "thumbnail": newImg14,
        'originalClass': 'homeImgs'
    },
    {
        'id': 28,
        'original': newImg15,
        "thumbnail": newImg15,
        'originalClass': 'homeImgs'
    },
    {
        'id': 29,
        'original': newImg16,
        "thumbnail": newImg16,
        'originalClass': 'homeImgs'
    },
    {
        'id': 3,
        'original': img2,
        "thumbnail": img2,
        'originalClass': 'homeImgs'
    },
    {
        'id': 2,
        'original': img3,
        "thumbnail": img3,
        'originalClass': 'homeImgs'
    },
    {
        'id': 5,
        'original': img5,
        "thumbnail": img5,
        'originalClass': 'homeImgs'
    },
    {
        'id': 6,
        'original': img4,
        "thumbnail": img4,
        'originalClass': 'homeImgs'
    },
    {
        'id': 7,
        'original': img8,
        "thumbnail": img8,
        'originalClass': 'homeImgs'
    },
    {
        'id': 8,
        'original': img6,
        "thumbnail": img6,
        'originalClass': 'homeImgs'
    },
    {
        'id': 9,
        'original': img7,
        "thumbnail": img7,
        'originalClass': 'homeImgs'
    },
    {
        'id': 10,
        'original': img9,
        "thumbnail": img9,
        'originalClass': 'homeImgs'
    },
    {
        'id': 11,
        'original': img12,
        "thumbnail": img12,
        'originalClass': 'homeImgs'
    },
    {
        'id': 12,
        'original': img13,
        "thumbnail": img13,
        'originalClass': 'homeImgs'
    },
    {
        'id': 13,
        'original': img14,
        "thumbnail": img14,
        'originalClass': 'homeImgs'
    },

]

const floorPlanImages = [

    [
        {
            'original': card1img1,
            "thumbnail": card1img1,
            'model': 1551,
            'originalClass': 'cardImgs'
        },
        {
            'original': card1img2,
            "thumbnail": card1img2,
            'model': 1551,
            'originalClass': 'cardImgs'
        },
        {
            'original': card1img3,
            "thumbnail": card1img3,
            'model': 1551,
            'originalClass': 'cardImgs'
        }
    ],
    [
        {
            'original': card2img1,
            "thumbnail": card2img1,
            'model': 1551,
            'originalClass': 'cardImgs'
        },
        {
            'original': card2img2,
            "thumbnail": card2img2,
            'model': 1551,
            'originalClass': 'cardImgs'
        },
        {
            'original': card2img3,
            "thumbnail": card2img3,
            'model': 1551,
            'originalClass': 'cardImgs'
        }
    ],
    [
        {
            'original': card3img1,
            "thumbnail": card3img1,
            'model': 1558,
            'originalClass': 'cardImgs'
        },
        {
            'original': card3img2,
            "thumbnail": card3img2,
            'model': 1558,
            'originalClass': 'cardImgs'
        },
        {
            'original': card3img3,
            "thumbnail": card3img3,
            'model': 1558,
            'originalClass': 'cardImgs'
        },
    ]
]



export { homeImages, floorPlanImages }